module.exports = __webpack_public_path__ + "img/12_27.f28b5043.png";